<template>
  <div>
    <b-row>
      <b-col>
        <table class="table table-sm text-center">
          <thead class="t-head thead-light text-center">
            <tr>
              <td v-translate>Star rating</td>
              <td v-translate>Value added per room</td>
              <td v-translate>Percentage applied</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="stars in order" :key="'fee' + stars">
              <td>
                {{ stars }}*
              </td>
              <td>
                <b-form-group class="mb-0">
                <b-input
                  type="number"
                  v-model="fees[stars].value"
                  size="sm" />
                </b-form-group>
              </td>
              <td>
                <b-form-group class="mb-0">
                <b-input
                  type="number"
                  v-model="fees[stars].percent"
                  size="sm" />
                </b-form-group>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'HotelFeesEdit',
  props: ['fees'],
  data () {
    return {
      order: [5, 4, 3, 2, 1]
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
